"use strict";
/* global google */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../../helpers/http");
var form_1 = require("../form");
var apiKey = 'AIzaSyD1IdE38YRd1qKGhe8G-aG4EWsvdLBgHCQ';
var baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
var GmStaticController = /** @class */ (function (_super) {
    __extends(GmStaticController, _super);
    function GmStaticController(config, dialog, uploads, $interpolate, $scope, book) {
        'ngInject';
        var _this = _super.call(this, $scope, book) || this;
        _this.config = config;
        _this.dialog = dialog;
        _this.uploads = uploads;
        _this.$interpolate = $interpolate;
        _this.options = {
            lat: '',
            lng: '',
            maptype: 'roadmap',
            height: 1024,
            width: 768,
            zoom: 15,
            scale: 2,
            style: []
        };
        _this.coordinates = {
            lat: '',
            lng: ''
        };
        _this.options = Object.assign(_this.options, _this.gmStaticOptions);
        _this.coordinates.lat = _this.getForeignValue(_this.options.lat);
        _this.coordinates.lng = _this.getForeignValue(_this.options.lng);
        _this.form.value = _this.book.get(_this.prefix, _this.id);
        uploads.setOption(_this.prefix, _this.id, $scope.option);
        $scope.$watch(function () { return uploads.uploads; }, function () {
            var upload = _this.uploads.getUpload(_this.prefix + "." + _this.id);
            var filename = upload ? upload.name : '';
            if (filename !== _this.form.value) {
                _this.setValue(filename);
            }
            _this.form.setValidity(_this.form.validation, !!filename || !!_this.form.isDisabled());
        }, true);
        $scope.$watch(function () { return book; }, function () { return _this.onChange(); }, true);
        $scope.$watch(function () { return _this.form.isDisabled(); }, function (value) {
            if (value) {
                _this.uploads.resetUpload(_this.prefix + "." + _this.id);
                _this.form.setValidity(_this.form.validation, true);
            }
            else {
                var valid = _this.form.hasValidation('required') ? !!_this.form.value : true;
                _this.form.setValidity(_this.form.validation, valid);
            }
        }, true);
        return _this;
    }
    GmStaticController.prototype.setValue = function (value) {
        this.form.value = value;
        this.book.set(this.prefix, this.id, this.form.value);
    };
    GmStaticController.prototype.onChange = function () {
        var _this = this;
        if (this.form.isDisabled()) {
            this.coordinates = { lat: '', lng: '' };
            return;
        }
        var lat = this.$interpolate("{{" + this.options.lat + "}}")(this.book);
        var lng = this.$interpolate("{{" + this.options.lng + "}}")(this.book);
        if (lat === this.coordinates.lat && lng === this.coordinates.lng) {
            return;
        }
        this.coordinates.lat = lat;
        this.coordinates.lng = lng;
        if (!this.coordinates.lat || !this.coordinates.lng) {
            if (this.form.hasValidation('required')) {
                this.form.setValidity(this.form.validation, false);
            }
            return;
        }
        var params = [
            "center=" + this.coordinates.lat + "," + this.coordinates.lng,
            "zoom=" + this.options.zoom,
            "size=" + this.options.width + "x" + this.options.height,
            "format=jpg",
            "scale=" + this.options.scale,
            "maptype=" + this.options.maptype,
            "style=" + this.options.style.join('&style='),
            "key=" + apiKey
        ];
        var url = baseUrl + "?" + params.join('&');
        this.uploads.prepare();
        var img = http_1.default.get(url, {
            method: 'GET',
            responseType: 'blob'
        }).then(function (response) {
            var reader = new FileReader();
            reader.onload = function (evt) {
                var dataUrl = evt.target.result;
                _this.uploads.setFileRef(_this.prefix, _this.id, null, false);
                _this.uploads.uploadImage(dataUrl);
            };
            reader.readAsDataURL(response.data);
        }, function (e) {
            _this.uploads.cancel();
            var message = _this.config.localeJson.ui.dialogs.mapsImageError.text;
            if (e.statusText) {
                message = message.concat(message, "<br />(" + e.statusText + ")");
            }
            _this.dialog.show(message, {
                title: _this.config.localeJson.ui.dialogs.mapsImageError.title,
                buttons: [{ label: _this.config.localeJson.ui.dialogs.mapsImageError.button.ok }]
            });
        });
    };
    GmStaticController.prototype.getForeignValue = function (key) {
        var _a = key.split('.'), group = _a[0], id = _a[1];
        return this.book.get(group, id) || '';
    };
    return GmStaticController;
}(form_1.FormOptionController));
exports.GmStaticController = GmStaticController;
function GmStaticDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/gm-static.html',
        controller: GmStaticController,
        controllerAs: 'gmStaticCtrl'
    };
}
exports.GmStaticDirective = GmStaticDirective;
